<template>
  <v-app>
     <v-layout>
      <v-flex>
        <v-card>
          <v-toolbar card prominent dense dark color="#084776">
            <v-toolbar-title class="text-xs-center"> <span >Sveučilište u Mostaru - Ispitni rokovi</span>
            </v-toolbar-title> 
                     
          </v-toolbar>
          <v-card-text class="grey lighten-3">
           
            
            <v-img :src ="require('@/assets/sumlogo.svg')" contain
            height="100px"
            ></v-img>
          </v-card-text>
          
        </v-card>
    <v-content>
      <Izbornik/>
      
    </v-content>
    <v-content  style="padding-top: 0px; background-color: #4c4c4c;">
      <Footer/>
    </v-content>
    </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
import Izbornik from "./components/Izbornik";
import Footer from "./components/Footer";


export default {
  name: 'App',
  components: {
    Izbornik,
    Footer,
  },
  data () {
    return {
      //
    }
  }
}
</script>
